import { cryptoInstance } from '@/public/fetch/index';
import { liveApi2 } from '@/public/utils/basePath';
const baseURL = liveApi2;
export const demo = () => {
    return cryptoInstance.get('', { baseURL: liveApi2 });
};
// 直播预约
export const liveSubscribe = (params) => {
    return cryptoInstance.get(`/live_stream/subscribe`, { baseURL, params });
};
// 直播订单详情
export const getLiveDetail = (orderId) => {
    return cryptoInstance.get(`/live_stream_order/detail/${orderId}`, {
        baseURL
    });
};
// 直播间小黄车商品列表
export const getLiveGoods = (userId, liveId) => {
    return cryptoInstance.get(`/live_stream_cart/list/${userId}/${liveId}`, {
        baseURL
    });
};
